export default function usePageTitle(pageTitle) {

    document.title = pageTitle;
}
